import React from 'react';

const QuotePostLineContext = React.createContext({});

export default QuotePostLineContext;
